import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { logout } from '../redux/actions/auth';
import { LoginScreen } from '../screens/login/LoginScreen';
import { LayoutSignDocument } from '../screens/SignDocument/layout/LayoutSignDocument ';
import { MainRouter } from './MainRouter';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import { ChartsScreen } from '../screens/charts/ChartsScreen';
import { SharedViews } from '../screens/sharedViews/SharedViewsScreen';
import { LayoutResponse } from '../screens/epayco/layout/LayoutResponse';
import EpaycoScreen from '../screens/epayco/EpaycoScreen';

import { NotFoundPage } from '../screens/notFound/NotFoundPage';

export default function AppRouter() {
    const { isAuth } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
        if (!user || !user?.token) {
            dispatch(logout());
        }

        if (moment(user?.accessDate).diff(moment(), 'hours') > 0) {
            dispatch(logout());
        }
    }, []);

    return (
        <Router>
            <Routes>
                {/* Rutas privadas agrupadas */}
                <Route
                    path="/*"
                    element={
                        <PrivateRoute isAuth={isAuth}>
                            <MainRouter />
                        </PrivateRoute>
                    }
                />
                {/* Rutas privadas agrupadas */}

                {/* Rutas públicas */}
                <Route
                    path="/login/*"
                    element={
                        <PublicRoute isAuth={isAuth}>
                            <LoginScreen />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/sign/:token"
                    element={
                        <PublicRoute isAuth={isAuth}>
                            <LayoutSignDocument />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/charts-viewer/:token/:id"
                    element={
                        <ChartsScreen />
                    }
                />
                <Route
                    path="/grid-viewer/:token/:id"
                    element={
                        <SharedViews />
                    }
                />
                <Route
                    path="/registration/:subscriptionPlan"
                    element={
                        <EpaycoScreen />
                    }
                />
                <Route
                    path="/payment-response"
                    element={
                        <LayoutResponse />
                    }
                />
                {/* Rutas públicas */}
                <Route
                    path="*"
                    element={<NotFoundPage />}
                />
            </Routes>
        </Router>
    );
}

